import WTSlogo from "assets/images/logo.png";
import IlustrationImage from "assets/images/SchoolBus.webp";
const LeftContent = () => {
  return (
    <div
      style={{
        display: "flex",
        width: "50%",
        height: "100%",
        backgroundColor: "#F5F5F5",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "1.25rem",
          color: "#555555",
          gap: "1.25rem",
          width: "100%",
          height: "100%",
        }}
      >
        <div>
          <img
            src={WTSlogo}
            alt="logo"
            style={{
              width: "auto",
              height: "33px",
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "0px 32px",
            marginBottom: "1.25rem",
            gap: 3,
          }}
        >
          <div
            style={{
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            School Bus System
          </div>
          <div
            style={{
              fontSize: "10px",
              maxWidth: "300px",
            }}
          >
            Centralized management for bookings, routes, schedules, and
            reporting.
          </div>
        </div>
        <img
          src={IlustrationImage}
          alt="IlustrationImage"
          style={{
            width: "auto",
            maxHeight: "250px",
            objectFit: "contain",
          }}
        />
      </div>
    </div>
  );
};

export default LeftContent;
